AGA.Schedule = (function () {
    var CLASSES = {
        autoInit: "aga-autoinit",
        noPerson: "aga-no-schedule-person",
        noEmployee: "aga-no-schedule-employee",
        needUpdate: "aga-need-update"
    };

    var SELECTOR = {
        calendar: ".aga-calendar",
        calendarBody: ".aga-calendar-body",
        calendarPlaceHolder: ".aga-calendar-placeholder",
        needUpdate: ".aga-need-update"
    };

    var isAllDay = function (mmt, mmtFim) {

        if (mmt.hour() !== 0 && mmt.minute() !== 0)
            return false;

        var fh = mmtFim.hour();
        if (fh !== 0 && fh !== 23)
            return false;
        var fm = mmtFim.minute();
        if (fm !== 0 && fm !== 59)
            return false;
        return true;
    };

    var getRoot = function (anyTarget) {
        return $(anyTarget).closest(SELECTOR.calendar);
    };

    var getLookupSchedule = function (root) {
        return $(root).find("[data-name='SCHEDULE_LOOKUP']");
    };

    var getLookupPerson = function (root) {
        return $(root).find("[data-name='SCHEDULE_PERSON']");
    };

    var getLookupEmployee = function (root) {
        return $(root).find("[data-name='SCHEDULE_EMPLOYEE']");
    };

    var hasPerson = function (lookupPerson) {
        return lookupPerson.length > 0 && !$(lookupPerson).hasClass(CLASSES.noPerson);
    };

    var hasEmployee = function (lookupEmployee) {
        return lookupEmployee.length > 0 && !$(lookupEmployee).hasClass(CLASSES.noEmployee);
    };

    var getModalUrl = function (schedule, event, person, date, employee) {
        var dateStr = (date ? "&dt=" + date.format("YYYYMMDDHHmmss") : "");
        var empStr = (employee ? "&emp=" + employee : "");
        return AGA.Ajax.getUrlPath("aga/a/agenda/eventoagenda.aspx?imp=1" +
            "&s=" + schedule +
            "&pe=" + person +
            "&e=" + event +
            dateStr +
            empStr);
    };

    var getSchedulePersonSelectUrl = function () {
        return AGA.Ajax.getUrlPath("aga/a/agenda/eventoAgendaFiltro.aspx?imp=1");
    };

    var tryShowNewEventButton = function (root) {
        var mustHide = ($(root).data("readonly") === "S") || ($(root).data("interval") === "S");
        $(".aga-schedule-new-event").toggleClass("hide", mustHide);
    };

    var unblock = function (anyTarget) {
        var root = getRoot(anyTarget);

        tryShowNewEventButton(root);

        if (!$(root).hasClass("blocked"))
            return;

        $(root).removeClass("blocked")
            .find(SELECTOR.calendarPlaceHolder).each(
                function (index, item) {
                    AGA.Helper.unblockElement(item);
                });
    };

    var block = function (anyTarget) {
        var root = getRoot(anyTarget);
        if ($(root).hasClass("blocked"))
            return;

        $(root).addClass("blocked");
        AGA.Helper.blockElement($(root)
            .find(SELECTOR.calendarPlaceHolder)[0],
            "Selecione acima a agenda desejada");

        $(".aga-schedule-new-event").addClass("hide");
    };

    var canShowContent = function (anyTarget) {
        var root = getRoot(anyTarget);
        var lookupSchedule = getLookupSchedule(root);
        var mustBlock = (!lookupSchedule) || AGA.Lookup.isNull(lookupSchedule);
        if (!mustBlock) {
            var lookupPerson = getLookupPerson(root);
            var lookupEmployee = getLookupEmployee(root);

            if (hasPerson(lookupPerson) && !hasEmployee(lookupEmployee)) {
                mustBlock = AGA.Lookup.isNull(lookupPerson);
            } else if (hasPerson(lookupPerson) && hasEmployee(lookupEmployee)) {
                mustBlock = (AGA.Lookup.isNull(lookupPerson) && AGA.Lookup.isNull(lookupEmployee));
            }
        }
        return !mustBlock;
    };

    var getCurrentInfo = function (anyTarget) {
        var root = getRoot(anyTarget);
        var lookupSchedule = getLookupSchedule(root);
        var lookupPerson = getLookupPerson(root);
        var lookupEmployee = getLookupEmployee(root);
        var person = hasPerson(lookupPerson) ? AGA.Lookup.getValue(lookupPerson) : 0;
        var employee = hasEmployee(lookupEmployee) ? AGA.Lookup.getValue(lookupEmployee) : 0;
        var schedule = AGA.Lookup.getValue(lookupSchedule);

        if (schedule <= 0 && person > 0)
            schedule = lookupPerson[0].dataset.schedule;

        return {
            schedule: schedule,
            person: person,
            employee: employee
        }
    };

    var getUnavailabilityText = function (period, title) {
        var rowTemplate = '<div class="row"><label class="col-md-3">%label%</label><div class="col-md-9 bold">%value%</div></div>';
        var buildRow = function (label, value) {
            return rowTemplate
                .replace("%label%", label)
                .replace("%value%", value);
        };

        return buildRow("Período:", period) + buildRow("Descrição:", title);
    };

    var updateSourceBuilder = function (root) {
        var myRoot = root;
        return function (start, end, utc, callback) {

            var show = canShowContent(myRoot);
            if (!show)
                callback([]);
            else {
                var info = getCurrentInfo(myRoot);
                info.start = start.format("DD/MM/YYYY");
                info.end = end.format("DD/MM/YYYY");

                $.ajax({
                    url: AGA.Ajax.getUrlPath("api/AGAAgendaProvider"),
                    data: info,
                    cache: false,
                    dataType: "json",
                    success: function (data) {
                        $(myRoot).data("hash", data.ScheduleHash);
                        $(myRoot).data("person", data.PersonHash);
                        $(myRoot).data("readonly", data.ReadOnly);
                        $(myRoot).data("interval", (data.Interval && data.Interval > 0) ? "S" : "N");
                        $(myRoot).data("employee", data.EmployeeHash);
                        $(myRoot).data("isModalPage", data.IsModalPage);
                        $(myRoot).data("urlDefinition", data.UrlDefinition);


                        var events = data.Events.map(function (item) {
                            var startEvent = moment(item.Range.s);
                            var endEvent = moment(item.Range.e);
                            var cor = "#69a4e0";
                            if (item.Cor) {
                                cor = item.Cor
                            }
                            if (item.Title == "Indisponível")
                                cor = "#808080";
                            return {
                                id: item.Id,
                                start: startEvent,
                                end: endEvent,
                                title: item.Title,
                                allDay: isAllDay(startEvent, endEvent),
                                schedule: item.ScheduleHash,
                                person: item.PersonHash,
                                backgroundColor: cor,
                                endOfScale: item.eos,
                                employee: item.EmployeeHash,
                                isModalPage: item.IsModalPage,
                                urlDefinition: item.UrlDefinition
                            };
                        });

                        if (data.Availabilities && data.Availabilities.length) {
                            for (var index = 0; index < data.Availabilities.length; index++) {
                                var range = data.Availabilities[index];
                                var startAvail = moment(range.s);
                                var endAvail = moment(range.e);
                                var corDisponivel = "#1bbc9b";
                                if (range.Color)
                                    corDisponivel = range.Color;
                                     
                                events.push(
                                    {
                                        id: "new",
                                        start: startAvail,
                                        end: endAvail,
                                        title: "Disponível",
                                        allDay: isAllDay(startAvail, endAvail),
                                        schedule: data.ScheduleHash,
                                        person: data.PersonHash,
                                        employee: data.EmployeeHash,
                                        isModalPage: data.IsModalPage,
                                        urlDefinition: data.UrlDefinition,
                                        backgroundColor: corDisponivel,
                                        endOfScale: range.eos
                                    });
                            };
                        };

                        if (data.Unavailabilities && data.Unavailabilities.length) {
                            data.Unavailabilities.map(function (current) {
                                current.Ranges.map(function (range) {
                                    var startUn = moment(range.s);
                                    var endUn = moment(range.e);
                                    events.push(
                                        {
                                            id: "not",
                                            start: startUn,
                                            end: endUn,
                                            title: current.Title,
                                            rangeText: current.RangeText,
                                            allDay: isAllDay(startUn, endUn),
                                            backgroundColor: "#F3565D",
                                            resourceEditable: false,
                                            editable: false
                                        });
                                });
                            });
                        };

                        callback(events);
                        unblock(myRoot);
                    },
                    error: function (error) {
                        AGA.Helper.alert(AGA.Ajax.getErrorMessage(error));
                    }
                });
            }
        };
    };

    var updateContent = function (anyTarget) {
        var canUpdate = canShowContent(anyTarget);
        var root = getRoot(anyTarget);
        var calendar = $(root).find(SELECTOR.calendarBody);
        if (calendar[0] != null) {
            calendar.fullCalendar("refetchEvents");

            if (canUpdate) {
                //unblock(anyTarget);
            } else {
                block(anyTarget);
            }
        }
    };
    var disableCalendarOptions = function (e) {
        $(".fc-agendaDay-button").removeClass("fc-state-disabled");
        $(".fc-agendaDay-button").removeAttr("disabled");
        $(".fc-agendaDay-button").click();

        $(".fc-agendaWeek-button").addClass("fc-state-disabled");
        $(".fc-agendaWeek-button").attr("disabled", "disabled");

        $(".fc-month-button").addClass("fc-state-disabled");
        $(".fc-month-button").attr("disabled", "disabled");


    }

    var enableCalendarOptions = function () {

        $(".fc-agendaWeek-button").removeClass("fc-state-disabled");
        $(".fc-agendaWeek-button").removeAttr("disabled", "disabled");

        $(".fc-month-button").removeClass("fc-state-disabled");
        $(".fc-month-button").removeAttr("disabled", "disabled");

    }

    var scheduleChanged = function (e) {
        var showEmployeeSelection = "N"
        var showOptionAll = "S"
        var root = getRoot(e.currentTarget);
        var lookupSchedule = getLookupSchedule(root);

        if (parent.Benner.ModalPage.isOpen())
            showOptionAll = "N"

        var url = "AgaAgendas/Agendado?agenda=" + e.value + "&_=" + new Date().getTime() + "&showOptionAll=" + showOptionAll + "&ShowEmployeeSelection=";
        var urlPerson = AGA.Ajax.getUrlPath(url + showEmployeeSelection);
        $(".aga-schedule-scheduled").empty();
        $.get(urlPerson,
            function (data) {
                $(".aga-schedule-scheduled").html(data);
                AGA.Lookup.initAll();
                updateContent(e.currentTarget);
            });

        showEmployeeSelection = "S"
        var urlEmployee = AGA.Ajax.getUrlPath(url + showEmployeeSelection);
        $(".aga-schedule-scheduled-employee").empty();
        $.get(urlEmployee,
            function (data) {
                $(".aga-schedule-scheduled-employee").html(data);
                AGA.Lookup.initAll();
                updateContent(e.currentTarget);
            });

        if (e.value != "")
            $(".aga-scheduled-title").removeClass("hide");
        else
            $(".aga-scheduled-title").addClass("hide");

        if (lookupSchedule[0].value === "-1") {
            disableCalendarOptions();
        } else {
            enableCalendarOptions();
        }
    };

    var scheduledPersonChanged = function (e) {
        var root = getRoot(e.currentTarget);
        var lookupSchedule = getLookupSchedule(root);
        var lookupEmployee = getLookupEmployee(root);
        var lookupPerson = getLookupPerson(root);
        var selectedIndex = lookupPerson[0].selectedIndex;

        if (selectedIndex >= 0) {
            var lookupSelectedItem = $(lookupPerson[0][selectedIndex]);
            lookupPerson[0].setAttribute("data-schedule", lookupSelectedItem[0].dataset.schedule || "-1");
        } else {
            lookupPerson[0].setAttribute("data-schedule", "-1");
        }

        atualizarValoreslookups(lookupSchedule[0], lookupPerson[0], root, lookupEmployee[0]);

        updateContent(e.currentTarget);

        if (lookupPerson[0].value === "-1") {
            disableCalendarOptions();
        } else {
            enableCalendarOptions();
        }
    };

    var scheduledEmployeeChanged = function (e) {
        var root = getRoot(e.currentTarget);
        var lookupSchedule = getLookupSchedule(root);
        var lookupPerson = getLookupPerson(root);
        var lookupEmployee = getLookupEmployee(root);
        var selectedIndex = lookupEmployee[0].selectedIndex;

        if (selectedIndex >= 0) {
            var lookupSelectedItem = $(lookupEmployee[0][selectedIndex]);
            lookupEmployee[0].setAttribute("data-schedule", lookupSelectedItem[0].dataset.schedule || "-1");
        } else {
            lookupEmployee[0].setAttribute("data-schedule", "-1");
        }

        atualizarValoreslookups(lookupSchedule[0], lookupPerson[0], root, lookupEmployee[0]);

        updateContent(e.currentTarget);

        if (lookupEmployee[0].value === "-1") {
            disableCalendarOptions();
        } else {
            enableCalendarOptions();
        }
    };

    var atualizarValoreslookups = function (schedule, person, root, employee) {
        var personValue = person.value != "" ? person.value : "0";
        var employeeValue = employee && employee.value != "" ? employee.value : "0";
        var dataObject = { Schedule: schedule.value, Person: personValue, Employee: employeeValue };
        $.ajax({
            url: AGA.Ajax.getUrlPath("api/AGAAgendaProvider/GetEncryptedHandles"),
            data: dataObject,
            cache: false,
            dataType: "json",
            success: function (data) {
                $(root).data("hash", data.ScheduleHash);
                $(root).data("person", data.PersonHash);
                $(root).data("employee", data.EmployeeHash);
            },
            error: function (error) {
                AGA.Helper.alert(AGA.Ajax.getErrorMessage(error));
            }
        });

    };

    var modalClose = function () {
        AGA.log("AGA.Schedule.modalClose");
        Benner.WidgetCommandsBar.disposeModal();

        if (parent.Benner.ModalPage.isOpen())
            parent.Benner.ModalPage.hide();

        $(SELECTOR.needUpdate).each(function (index, item) {
            $(item).removeClass(CLASSES.needUpdate);
            updateContent(item);
        });
    };

    var openModal = function (url) {
        AGA.log("AGA.Schedule.openModal");
        var config = {
            url: url,
            id: "aga-schedule-modal",
            size: "large",
            height: 750,
            displayFooter: false,
            displayTitle: false,
            title: ""
        };

        Benner.ModalPage.show(config,
            Benner.WidgetCommandsBar.openModal,
            modalClose);
    };

    var openModalFromUrlDefinition = function (eventUrlDefinition) {
        Benner.Widget.prepareModal(eventUrlDefinition, "", "Large");
    };

    var openNewPage = function (eventUrlDefinition) {
        document.location.href = document.location.origin + eventUrlDefinition;
    };

    var getConfig = function (root) {
        return {
            header: {
                //left: "prev,next today",
                left: "title",
                center: "",
                right: "prev,next today,agendaDay,agendaWeek,month"
            },
            monthNames: [
                "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro",
                "Novembro", "Dezembro"
            ],
            monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
            dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
            dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
            timeFormat: "HH:mm ",
            axisFormat: "HH:mm",
            allDayText: "Hora",
            lazyFetching: false,
            buttonText: {
                today: "Hoje",
                month: "Mês",
                week: "Semana",
                day: "Dia"
            },
            displayEventTime: false,
            allDaySlot: false,
            slotDuration: "00:10:00",
            slotEventOverlap: false,
            scrollTime: "06:00:00",
            columnFormat: {
                day: "ddd DD/MM",
                week: "ddd DD/MM",
                month: "ddd"
            },
            titleFormat: {
                month: "MMMM/YYYY",
                day: "ddd - DD/MM/YYYY",
                week: "DD/MM/YYYY"
            },
            eventSources: [updateSourceBuilder(root)],

            eventRender: function (event, element) {
                if (event.allDay) {
                    $(element).find(".fc-time").addClass("hide");
                }
                if (event.id === "not") {
                    $(element).find(".fc-time").text(event.start.format("HH:mm") + " - " + event.end.format("HH:mm"));
                }


                if (event.endOfScale) {
                    $(element).css("border-bottom", "solid 2px #F3565D");
                } else {
                    $(element).css("border-bottom", "solid 1px #eee");
                }
            },
            eventClick: function (calEvent) {

                // alert('Event: ' + calEvent.schedule);
                // alert('Id: ' + calEvent.id);
                // alert('View: ' + view.name);

                if (calEvent.schedule) {

                    if (calEvent.urlDefinition != null) {

                        if (calEvent.isModalPage == "N") {

                            openNewPage(calEvent.urlDefinition);
                        } else {
                            openModalFromUrlDefinition(calEvent.urlDefinition);
                        }
                    } else {
                        var url = getModalUrl(calEvent.schedule, calEvent.id, calEvent.person, calEvent.start);
                        openModal(url);
                    }
                } else {
                    callNewEvent(calEvent.start);
                }
            }
        };
    };

    var callNewEvent = function (d) {
        $(".aga-calendar").each(function (index, item) {
            $(item).removeClass(CLASSES.autoInit);
            var calendar = $(item).find(SELECTOR.calendarBody);
            if (calendar[0] != null) {
                calendar.fullCalendar(getConfig(item));
                newEvent(item, d);
            }
        });
    };

    var initAll = function () {
        $(".aga-calendar").each(function (index, item) {
            $(item).removeClass(CLASSES.autoInit);
            var calendar = $(item).find(SELECTOR.calendarBody);
            if (calendar[0] != null) {
                calendar.fullCalendar(getConfig(item));
                block(item);
            }
        });
    };

    var needUpdate = function () {
        AGA.log("AGA.Schedule.needUpdate call");
        $(SELECTOR.calendar).addClass(CLASSES.needUpdate);
    };

    var newEvent = function (e,d) {
        var root = getRoot(e);
        var schedule = $(root).data("hash");
        var person = $(root).data("person");
        var lookupEmployee = getLookupEmployee(root);
        var lookupSchedule = getLookupSchedule(root)[0];

        if (AGA.Helper.isNullValue(lookupSchedule) || lookupSchedule.value === "") {
            AGA.Helper.alert("O campo de agenda deve ser preenchido");
        } else {
            var url;
            if (lookupSchedule.value === "-1") {
                url = getSchedulePersonSelectUrl();
            } else {
                if (!hasEmployee(lookupEmployee)) {
                    if (AGA.Helper.isNullValue(schedule))
                        url = getModalUrl(lookupSchedule.value, "new", person);
                    else
                        url = getModalUrl(schedule, "new", person);
                } else {
                    var employee = $(root).data("employee");
                    if (AGA.Helper.isNullValue(schedule))
                        url = getModalUrl(lookupSchedule.value, "new", person, d, employee);
                    else
                        url = getModalUrl(schedule, "new", person, d, employee);
                }
            }

            openModal(url);
        }
    };

    return {
        initAll: initAll,
        scheduleChanged: scheduleChanged,
        scheduledPersonChanged: scheduledPersonChanged,
        scheduledEmployeeChanged: scheduledEmployeeChanged,
        needUpdate: needUpdate,
        newEvent: newEvent
    };

})();

$(document).ready(function () { AGA.Schedule.initAll(); });